// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AppProvider } from './contexts/AppContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
const googleWebClientId = process.env.REACT_APP_GOOGLE_WEB_CLIENT_ID
  || "659580568813-ejmnbf8hc4udodn8tj5uuv5om60cgd3g.apps.googleusercontent.com";

root.render(
    <GoogleOAuthProvider clientId={googleWebClientId}>
      <AppProvider>
        <App />
      </AppProvider>
    </GoogleOAuthProvider>
);

reportWebVitals();
